<template>
  <div
    class="price-list"
    style="border: 1px solid #dedede; margin-bottom: 15px; border-radius: 5px"
  >
    <div
      class="text-xs-center"
      @click="showProduct = !showProduct"
      style="
        padding: 5px;
        border-bottom: 1px solid #eee;
        background: white;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        cursor: pointer;
      "
    >
      {{ $t('Tab to view your shopping cart') }}
      <v-icon v-if="showProduct">mdi-chevron-up</v-icon>
      <v-icon v-else>mdi-chevron-down</v-icon>
    </div>
    <div
      class="row"
      style="border-bottom: 1px solid #dedede"
      v-if="showProduct"
    >
      <template v-for="(bundle, index) in filterBundles">
        <template v-if="bundle.id != 'other'">
          <BundleGroup :key="bundle.id" :bundle="bundle">
            <template v-for="(product, pindex) in bundle.filterCart">
              <cart-item
                :key="'product_' + pindex"
                :product="product"
              ></cart-item>
            </template>
          </BundleGroup>
          <v-divider
            v-if="index != filterBundles.length - 1"
            :key="`divider_${bundle.id}`"
          />
        </template>
        <template v-else>
          <Pagination v-model="bundle.filterCart" :key="bundle.id">
            <template v-slot="{ item, index }">
              <cart-item :key="'product_' + index" :product="item"></cart-item>
            </template>
          </Pagination>
        </template>
      </template>
    </div>
    <v-layout
      v-if="isYasale"
      wrap
      row
      style="padding: 5px; border-bottom: 1px solid #dedede; background: white"
    >
      <v-flex xs6>{{ $t('Price') }}</v-flex>
      <v-flex xs6 class="price text-right"
        >{{ currencySign
        }}{{ totalPriceBeforeDiscount | decimalFormat }}</v-flex
      >
    </v-layout>
    <v-layout
      v-else-if="!$store.getters.isPowerBuyPage"
      wrap
      row
      style="padding: 5px; border-bottom: 1px solid #dedede; background: white"
    >
      <v-flex xs6>{{ $t('Price') }}</v-flex>
      <v-flex xs6 class="price text-right"
        >{{ currencySign }}{{ total | decimalFormat }}</v-flex
      >
    </v-layout>
    <template v-if="isYasale">
      <v-layout
        wrap
        row
        style="
          padding: 5px;
          border-bottom: 1px solid #dedede;
          background: white;
        "
      >
        <v-flex xs6>{{ $t('service_fee_withholding_tax') }}</v-flex>
        <v-flex xs6 class="price text-right"
          >{{ currencySign }}{{ totalDiscount | decimalFormat }}</v-flex
        >
      </v-layout>
      <v-layout
        wrap
        row
        style="
          padding: 5px;
          border-bottom: 1px solid #dedede;
          background: white;
        "
      >
        <v-flex xs6>{{ $t('Subtotal') }}</v-flex>
        <v-flex xs6 class="price text-right"
          >{{ currencySign }}{{ totalincludediscount | decimalFormat }}</v-flex
        >
      </v-layout>
    </template>
    <template v-else-if="discount">
      <v-layout
        wrap
        row
        style="
          padding: 5px;
          border-bottom: 1px solid #dedede;
          background: white;
        "
      >
        <v-flex xs6>{{ $t('Discount') }}</v-flex>
        <v-flex xs6 class="price text-right"
          >-{{ currencySign }}{{ discount | decimalFormat }}</v-flex
        >
      </v-layout>
      <v-layout
        wrap
        row
        style="
          padding: 5px;
          border-bottom: 1px solid #dedede;
          background: white;
        "
      >
        <v-flex xs6>{{ $t('Subtotal') }}</v-flex>
        <v-flex xs6 class="price text-right"
          >{{ currencySign }}{{ totalincludediscount | decimalFormat }}</v-flex
        >
      </v-layout>
    </template>

    <v-layout
      wrap
      row
      v-if="totalVat && !isYasale"
      style="padding: 5px; border-bottom: 1px solid #dedede; background: white"
    >
      <v-flex xs6>
        {{ $t('Vat') }}
      </v-flex>
      <v-flex xs6 class="price text-right">
        {{ currencySign }}{{ totalVat | decimalFormat }}
      </v-flex>
    </v-layout>

    <template
      v-if="
        (pageProfile.type != 'nvbb' ||
          (pageProfile.type == 'nvbb' && shippingPrice != 0)) &&
        !$store.getters.isPowerBuyPage
      "
    >
      <v-layout
        wrap
        row
        style="
          padding: 5px;
          border-bottom: 1px solid #dedede;
          background: white;
        "
        v-if="
          isCustomize ||
          shippingType ||
          additionalproduct_charge != 0 ||
          isBearhouse ||
          isCDS
        "
      >
        <v-flex xs6>
          {{ $t('Shipping fee') }}
          <span v-if="isKhaiwhan">{{ '(จ่ายกับพนักงานขนส่ง)' }}</span>
          <template v-if="transportCode && transportCost">
            <template v-if="transportCode == 'MET'">
              ({{ $t('Shipping Fee (Bangkok and surrounding)') }})
            </template>
            <template v-else-if="transportCode == 'FAR'">
              ({{ $t('Shipping Fee (remote area)') }})
            </template>
            <template v-else-if="transportCode == 'UPC'">
              ({{ $t('Shipping Fee (up-country)') }})
            </template>
          </template>
        </v-flex>
        <v-flex xs6 class="price text-right">
          <template v-if="isCDS">
            <div v-if="cdsshippingprice">
              {{ currencySign }}{{ cdsshippingprice | decimalFormat }}
            </div>
            <template v-else-if="!zipCode || zipCode.length < 5"> - </template>
            <div v-else>{{ $t('Free') }}</div>
          </template>

          <template
            v-else-if="
              isBearhouse ||
              isKhaiwhan ||
              ['purelife', 'gaigacha', 'kanom', 'fastdeli'].includes(
                pageProfile.type
              )
            "
          >
            <template v-if="ableToBuy">
              <template v-if="shippingPrice !== 0">
                {{ currencySign }}{{ shippingPrice | decimalFormat }}
              </template>
              <template v-else-if="!zipCode || zipCode.length < 5">
                -
              </template>
              <template v-else> {{ $t('Free') }}</template>
            </template>
            <template v-else>ไม่สามารถจัดส่งได้</template>
          </template>
          <template v-else-if="isKullastri || isBSC">
            {{ currencySign }}{{ customerShippingPrice | decimalFormat }}
          </template>
          <template v-else-if="shippingType">
            <template v-if="shippingType.value === false || notShipping">
              {{ 'ไม่สามารถจัดส่งได้' }}
            </template>
            <template v-else-if="isSmoothE">
              <template v-if="total < 500"
                >{{ currencySign
                }}{{ shippingType.value | decimalFormat }}</template
              >
              <template v-else-if="!zipCode || zipCode.length < 5">
                -
              </template>
              <template v-else>{{ $t('Free') }}</template>
            </template>
            <template v-else-if="shippingPrice === 0">
              <span v-if="!zipCode || zipCode.length < 5"> - </span>
              <span v-else>
                {{ $t('Free') }}
              </span>
            </template>
            <template v-else>
              {{ currencySign }}{{ shippingPrice | decimalFormat }}
            </template>
          </template>

          <template v-else>{{ currencySign }}{{ 0 | decimalFormat }}</template>
        </v-flex>
      </v-layout>
    </template>

    <v-layout
      wrap
      row
      style="padding: 5px; border-bottom: 1px solid #dedede; background: white"
      v-if="voucher && shippingPriceIncludeDiscount > 0 && shippingPrice > 0"
    >
      <v-flex xs6>
        {{ $t('Discount') + ' ' + $t('Shipping fee') }}
      </v-flex>
      <v-flex xs6 class="price text-right">
        -{{ currencySign }}{{ shippingPriceIncludeDiscount | decimalFormat }}
      </v-flex>
    </v-layout>

    <template
      v-if="
        $store.state.bundles.bundleDiscount &&
        $store.state.bundles.bundleDiscount.nestle_discount_bundle
      "
    >
      <v-layout
        wrap
        row
        style="
          padding: 5px;
          border-bottom: 1px solid #dedede;
          background: white;
        "
      >
        <v-flex xs6>
          {{ $t('Bundle Discount') }}
        </v-flex>
        <v-flex xs6 class="price text-right">
          -{{ currencySign
          }}{{
            $store.state.bundles.bundleDiscount.nestle_discount_bundle
              | decimalFormat
          }}
        </v-flex>
      </v-layout>
    </template>

    <v-layout
      wrap
      row
      class="totalprice"
      style="
        padding: 5px;
        background: white;
        border-bottom-left-radius: 5px;
        border-bottom-right-radius: 5px;
      "
    >
      <v-flex xs6>
        <template v-if="isYasale">{{ $t('total_paid_amount') }}</template>
        <template v-else>{{ $t('grand_total') }}</template>
      </v-flex>

      <v-flex xs6 class="price text-right"
        >{{ currencySign }}{{ grandTotal | decimalFormat }}</v-flex
      >
    </v-layout>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import CartItem from '@/components/payment/CartItem.vue'
import Pagination from '@/components/Pagination.vue'
import BundleGroup from '@/components/ecommerce/Bundles/BundleGroup.vue'

export default {
  props: {
    total: {
      default: undefined
    },
    totalincludediscount: {
      default: undefined
    },
    discount: {
      default: undefined
    },
    shippingType: {
      default: undefined
    },
    additionalproduct_charge: {
      default: undefined
    },
    bearhouseshippingprice: {
      default: undefined
    },
    cdsshippingprice: {
      default: undefined
    },
    khaiwhanshippingprice: {
      default: undefined
    },
    customerShippingPrice: {
      default: undefined
    },
    isCustomize: {
      default: false
    },
    ableToBuy: {
      default: true
    },
    notShipping: {
      default: false
    },
    voucher: {},
    exceptCashOnDelivery: {
      default: false
    },
    transportCode: {
      default: null
    },
    transportCost: {
      default: null
    },
    zipCode: {
      default: null
    }
  },
  data: function () {
    return {
      showProduct: false
    }
  },
  mounted() {
    if (this.pageProfile.type == 'chillpainai') this.showProduct = true
  },
  components: {
    CartItem,
    Pagination,
    BundleGroup
  },
  computed: {
    filterBundles() {
      let cart = [...this.cart]
      const bundles = this.$store.getters['bundles/availableBundles']
      return this.getMatchBundleGroup(bundles, cart)
    },
    shippingPrice() {
      var cost = 0
      try {
        if (
          (this.isCustomize ||
            this.shippingType ||
            this.additionalproduct_charge != 0 ||
            this.isBearhouse ||
            this.isKullastri ||
            this.isBSC ||
            this.isCDS) &&
          this.pageProfile.type != 'nvbb'
        ) {
          if (this.isCDS) cost = this.cdsshippingprice
          else if (
            this.isBearhouse ||
            this.isKhaiwhan ||
            ['purelife', 'gaigacha', 'kanom', 'fastdeli'].includes(
              this.pageProfile.type
            )
          ) {
            cost = this.customerShippingPrice
          } else if (this.shippingType && this.shippingType.value >= 0) {
            if (typeof this.shippingType.value == String)
              cost = parseFloat(this.shippingType.value)
            else cost = this.shippingType.value
          }
          if (this.transportCode && this.transportCost)
            cost += this.transportCost

          return cost
        } else {
          return false
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    },
    shippingPriceIncludeDiscount() {
      if (this.shippingPrice && this.voucher) {
        if (this.voucher.freeship) {
          if (
            this.shippingType.type == 'cod_charge' &&
            this.exceptCashOnDelivery
          ) {
            return false
          } else {
            return this.shippingPrice
          }
        } else if (this.shippingPrice >= this.voucher.discountship) {
          return this.voucher.discountship
        } else {
          return this.shippingPrice
        }
      }
      return 0
    },
    isGaiGao() {
      return this.pageProfile && this.pageProfile.type == 'gaigao'
    },
    isKhaiwhan() {
      return (
        this.pageProfile &&
        this.$store.state.khaiwhan.includes(this.pageProfile.pageid)
      )
    },
    isCDS() {
      return (
        this.pageProfile &&
        this.$store.state.cds.includes(this.pageProfile.pageid)
      )
    },
    isSmoothE() {
      return this.pageProfile && this.pageProfile.type == 'smoothe'
    },
    isKullastri() {
      return (
        this.pageProfile &&
        this.$store.state.kullastripage.includes(this.pageProfile.pageid)
      )
    },
    isBSC() {
      return (
        this.pageProfile &&
        this.$store.state.bscpage.includes(this.pageProfile.pageid)
      )
    },
    isBearhouse() {
      return (
        this.pageProfile &&
        this.$store.state.bearhouse.includes(this.pageProfile.pageid)
      )
    },
    isYasale() {
      return this.pageProfile && this.pageProfile.type === 'yasale'
    },
    ...mapGetters({
      cart: 'getCart',
      currentLang: 'currentLang',
      loadingPageProfile: 'getLoadingPageProfile',
      pageProfile: 'getPageProfile',
      currencySign: 'currencySign'
    }),
    totalPriceBeforeDiscount() {
      return this.filterBundles.reduce(
        (bundleTotal, { filterCart }) =>
          bundleTotal +
          filterCart.reduce(
            (cartTotal, { price, quantity }) => cartTotal + price * quantity,
            0
          ),
        0
      )
    },
    totalDiscount() {
      return this.totalPriceBeforeDiscount - this.total + this.discount
    },
    totalBeforeShippingPrice() {
      var price = 0
      if (this.isCDS) {
        price = this.totalincludediscount + this.cdsshippingprice
      } else if (
        this.isBearhouse ||
        this.isKhaiwhan ||
        this.isKullastri ||
        this.isBSC
      ) {
        price = this.totalincludediscount + this.customerShippingPrice
      } else if (this.shippingType) {
        if (this.isSmoothE && this.totalincludediscount >= 500)
          return this.totalincludediscount
        // let shipping_price = this.isNumber(this.shippingType.value) ? this.shippingType.value : 0;
        let shipping_price = this.shippingPrice || 0
        try {
          price = this.totalincludediscount + parseFloat(shipping_price)
        } catch (error) {
          price = this.totalincludediscount + shipping_price
        }
      } else {
        price = this.totalincludediscount
      }
      return price
    },
    totalVat() {
      let vat = 0
      if (this.pageProfile.vat) {
        vat = this.$store.getters.totalVat
        vat = this.roundNumber(vat)
      }

      return vat
    },
    grandTotal: function () {
      return (
        this.totalBeforeShippingPrice -
        this.shippingPriceIncludeDiscount +
        this.totalVat
      )
    }
  },
  methods: {
    isNumber(value) {
      let val = null
      try {
        val = parseInt(value)
      } catch (error) {
        return false
      }
      return typeof val === 'number' && isFinite(val)
    }
  }
}
</script>

<style lang="scss" scoped></style>
